module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/share-794c126e6e2a6963c87c274b0ef21995.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/share.svg
// module id = lygK
// module chunks = 24